@if (showNavbar) {
  <app-navbar></app-navbar>
}
<div [class]="showNavbar ? 'container-fluid mt-5' : ''">
  <router-outlet></router-outlet>
</div>
